import React from 'react';
import { cloneDeep } from 'lodash';

/**
 * @param {*} obj
 * @returns {string}
 */
export const getSearchIndexFromObject = (obj) => {
    const getSearchIndexFromArray = (arr) => arr.map(getSearchIndexFromObject);
    return Object
        .values(obj)
        // remove null, undefined, empty
        .filter((o) => !!o && !React.isValidElement(o))
        .map((val) => {
            // Number.isNan doesn't work as it should, the check for isNan is to detect invalid dates
            // @ts-ignore
            // eslint-disable-next-line no-restricted-globals
            if (val instanceof Date && !isNaN(val)) {
                return val.toISOString().replace('T', '__');
            }
            if (val instanceof Object) {
                return getSearchIndexFromObject(val);
            }
            if (val instanceof Array) {
                return val.map(getSearchIndexFromArray);
            }

            return val.toString();
        })
        .join('__')
        .toLocaleLowerCase();
};

/**
 * @template T
 * @param {T} obj
 */
export const addSearchIndex = (obj) => ({ ...obj, searchIndex: getSearchIndexFromObject(obj) });

/**
 * @template T
 * @param {T&{searchIndex?:string}} obj
 * @return {T}
 */
export const removeSearchIndex = (obj) => {
    const clone = cloneDeep(obj);
    delete clone.searchIndex;
    return clone;
};

/**
 * @template T
 * @param {T} obj
 * @returns {T|T&{searchIndex:string}}
 */
export const addSearchIndexSafe = (obj) => {
    if (!obj || !(obj instanceof Object) || !Object.keys(obj).length) {
        return obj;
    }

    return addSearchIndex(obj);
};
